import { Badge } from "@/components/base/badges/badges";

type SafetyStatus = "no_risks" | "needs_reviewing" | "needs_action" | null;

type Props = {
  safetyStatus: SafetyStatus;
};

/**
 * Maps safety status to display label
 */
const getSafetyStatusLabel = (status: SafetyStatus): string => {
  switch (status) {
    case "no_risks":
      return "No Risks";
    case "needs_reviewing":
      return "Needs Review";
    case "needs_action":
      return "Needs Action";
    default:
      return "--";
  }
};

/**
 * Maps safety status to badge color
 */
const getSafetyStatusColor = (status: SafetyStatus): "success" | "warning" | "error" | "gray" => {
  switch (status) {
    case "no_risks":
      return "success";
    case "needs_reviewing":
      return "warning";
    case "needs_action":
      return "error";
    default:
      return "gray";
  }
};

/**
 * Badge component for displaying video safety status.
 * Used in the Posted Video tab to show if any videos have flagged content.
 */
export const CreatorSafetyStatusBadge = ({ safetyStatus }: Props) => {
  if (!safetyStatus) {
    return <span className="text-sm text-tertiary">--</span>;
  }

  const label = getSafetyStatusLabel(safetyStatus);
  const color = getSafetyStatusColor(safetyStatus);

  return (
    <Badge color={color} size="sm">
      {label}
    </Badge>
  );
};
